export default __webpack_public_path__ + "static/media/11.94b6fa0e.jpg";